import {ChangeDetectionStrategy, Component, OnDestroy, OnInit} from '@angular/core';
import {interval, Subscription} from 'rxjs';
import {NgForOf, NgStyle} from "@angular/common";

interface WaveSegmentStyle {
  height: string;
  width: string;
  background?: string;
  left?: string;
  right?: string;
  borderBottomLeftRadius?: string;
  borderBottomRightRadius?: string;
}

@Component({
    selector: 'db-wave-background',
    templateUrl: './wave-background.component.html',
    styleUrls: ['./wave-background.component.scss'],
    imports: [
        NgStyle,
        NgForOf
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WaveBackgroundComponent implements OnInit, OnDestroy {
  private intervalSubscription?: Subscription;

  ngOnInit() {
    // Initialize wave segments
    setTimeout(() => {
      const segments = document.getElementsByClassName('wave-segment');
      Array.from(segments).forEach((element, index) => {
        const delay = -Math.random() * 5.95;
        (element as HTMLElement).style.animationDelay = `${delay}s`;
      });
    });

    // Set initial wave float variables
    this.setWaveFloatVariables();

    // Update wave float variables periodically
    this.intervalSubscription = interval(51000).subscribe(() => {
      this.setWaveFloatVariables();
    });
  }

  ngOnDestroy() {
    if (this.intervalSubscription) {
      this.intervalSubscription.unsubscribe();
    }
  }

  getSegmentStyle(color: string, index: number): WaveSegmentStyle {
    const height = 63.75 + Math.random() * 17;
    let opacity = color === 'purple' ? 0.7 : (color === 'blue' ? 0.7 : 0.8);
    opacity *= (0.8 + (color === 'purple' ? 0 : index) * 0.07);

    const style: WaveSegmentStyle = {
      height: `${height}%`,
      width: `${color === 'purple' ? 100 : (100 / 1.5)}%`
    };

    if (color === 'blue') {
      style.background = `rgba(51, 57, 241, ${opacity})`;
      style.left = `${10 + (index / 3 * 90)}%`;
      if (index === 0) {
        style.borderBottomLeftRadius = '100%';
        style.borderBottomRightRadius = '0';
      }
    } else if (color === 'green') {
      style.background = `rgba(92, 204, 129, ${opacity})`;
      style.right = `${(index / 3 * 100)}%`;
      style.left = 'auto';
      if (index === 2) {
        style.borderBottomLeftRadius = '0';
        style.borderBottomRightRadius = '100%';
      }
    } else if (color === 'purple') {
      style.background = `linear-gradient(90deg,
        rgba(51, 57, 241, ${opacity}) 0%,
        rgba(161, 165, 239, ${opacity}) 30%,
        rgba(161, 165, 239, ${opacity}) 70%,
        rgba(92, 204, 129, ${opacity}) 100%)`;
      style.left = '-40px';
    }

    return style;
  }

  private setWaveFloatVariables() {
    document.documentElement.style.setProperty(
      '--wave-float-y-25',
      `${-35.84 - Math.random() * 26.88}px`
    );
    document.documentElement.style.setProperty(
      '--wave-float-y-50',
      `${-26.88 - Math.random() * 17.92}px`
    );
    document.documentElement.style.setProperty(
      '--wave-float-y-75',
      `${-40.32 - Math.random() * 31.36}px`
    );
  }
}
